import { inject, Injectable } from '@angular/core';
import { Logger, LoggingService } from '../../logging/logging.service';
import { BasePageConfig, PageConfig } from '../../config/entities';
import { UserRoles } from '../../user/entities/user-roles';
import { ConfigService } from '../../config/services/config.service';
import { FeatureConfigs } from '../entities/curafida-frontend-configuration';
import { ConfigurationDetailFeatures } from '../../config/resources/configuration.resource';
import { CurafidaFeatureEnum } from '../../config/entities/base-page-config';

@Injectable({
    providedIn: 'root',
})
export class MenuService {
    private readonly loggingService = inject(LoggingService);
    configService = inject(ConfigService);

    roles: UserRoles[] | string[] = [];
    protected readonly log: Logger = this.loggingService.getLogger(this.constructor.name);

    fetchSubPageConfig(subPagesConfig: BasePageConfig[], roles: UserRoles[] | string[]) {
        return subPagesConfig?.filter((page) => this.hasRoleAndModule(page, roles));
    }

    private hasRoleAndModule(page: PageConfig, roles: UserRoles[] | string[]): boolean {
        return this.isModuleEnabled(page) && page.role.some((pageRole) => roles?.includes(pageRole as UserRoles));
    }

    private isModuleEnabled(page: PageConfig): boolean {
        if (page?.module === CurafidaFeatureEnum.common) {
            return true;
        }
        const pageModule = page?.module as keyof ConfigurationDetailFeatures;
        const backendFeature = this.configService.config()?.configuration?.features?.[pageModule];
        if (backendFeature) {
            return !!backendFeature.enabled;
        }
        return !!this.configService.frontendConfig().features?.[pageModule as keyof FeatureConfigs]?.enabled;
    }
}
